import React from 'react'
import './trainerProfile.css'
import Menubar from '../home/menubar/Menubar'
import Address from '../home/footer/Address'
import ScrollToTopProgress from '../home/header/ScrollToTopProgress'
import {trainerImg} from '../home/data.js'
import Header from '../home/header/Header.jsx'
import LazyImage from '../LazyImage.jsx'

function TrainerProfile() {
    const {trainer_url}=trainerImg
  return (
    <div>
      <Header/>
      <Menubar/>
    <div>

	<section className='header-title'>
		<div>
			<h1>OUR PROFESSIONAL TRAINER</h1>
            <h5 style={{borderBottomStyle: 'groove', top:'10px'}}>More than 15 years of experience in various domains</h5>
		</div>
	</section>

            <div className="container">
		 <div className="row">

            <div className="container mt-4 col-md-2 col-sm-2 contrainer-left-data">
                <div>
                    <LazyImage className='trainer-img' src={trainer_url} alt='contact-Us'/>
                    <p>Mr.M.Chandra Sekhar (B.com, Multimedia)</p>
                </div>
            </div>

                <div className="container mt-4 col-md-8 col-sm-10 contrainer-right-data">
					<div className="footer-content">
						<p style={{textAlign: 'center'}}><b>Adarsh Computers: Empowering IT Careers Through Excellence in Education</b></p>
                        <p>With over 15 years of proven experience in the IT industry across various domains, Adarsh Computers has established itself as a trusted name in IT education and career development. Driven by the vision to bridge the gap between education and employment, the management is deeply committed to empowering youth by providing high-quality, job-oriented training.</p>
                        <p>What sets Adarsh Computers apart is its innovative approach to preparing students for real-world careers. The training methodologies are carefully designed to align with current industry demands, resulting in strong positive feedback from both job seekers and hiring organizations.</p>
                        <p>At the heart of the organization is a dedicated core team and a group of passionate software trainers. Adarsh Computers emphasizes continuous development and ensures that its trainers deliver world-class instruction by adhering to high standards and embracing the latest advancements in technology.</p>
                        <p>Strong leadership and a clear strategic vision empower the entire team to perform at their best, ensuring the consistent delivery of top-tier training and services.</p>
                    </div>
                </div>


      

      </div>
      </div>

             {/* <div className="container strengths">
                <div className="row">
                  <div className="container mt-4 col-md-5 col-sm-10">
                    <div>
                    <h5>Training Infrastructure</h5>
                    <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Teaching skill</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Certification</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                  </div>

                    <div className="container mt-4 col-md-5 col-sm-10">
                      <div>
                      <h5>Programming Knowledge</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Professional Teacher</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Assignments</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>

                  </div>
              </div>
            </div> */}

            
        </div>

        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default TrainerProfile